// copied from https://github.com/ozansabrican/react-random-word
import * as React from 'react'


interface Props {
  speed: number
  rounds?: number
  letters?: string
  word?: string
  style?: React.CSSProperties
}

class WordShuffle extends React.Component<
  Props,
  { round: number; animationTimer: number }
> {
  constructor(props: Props) {
    super(props)
    this.state = {
      round: 0,
      animationTimer: 0,
    }
  }

  static defaultProps = {
    speed: 150,
    rounds: 10,
    letters: 'abcdef0123456789',
    style: {},
  }

  animation: number
  startAnimation = () => {
    this.state.animationTimer = window.setTimeout(
      this.animate,
      this.props.speed
    )
  }

  componentDidMount() {
    this.startAnimation()
  }
  componentWillUnmount() {
    window.clearTimeout(this.animation)
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.word !== this.props.word) {
      this.setState({ round: 0 }, this.startAnimation)
    }
  }
  shuffleWord = () => {
    return this.props.word
      .split('')
      .map((_, i) => this.randomSequenceFor(this.props.word[i]))
  }

  randomSequenceFor(letter: string) {
    const min = Math.floor(this.props.rounds / 3)
    const max = this.props.rounds
    const rounds = Math.floor(Math.random() * this.props.rounds)
    const length = Math.min(Math.max(rounds, min), max)

    return Array.from({ length })
      .map(() => {
        let randomLetter = this.randomLetter()
        while (randomLetter === letter) {
          randomLetter = this.randomLetter()
        }
        return randomLetter
      })
      .concat(letter)
  }

  randomLetter() {
    const position = Math.floor(Math.random() * this.props.letters.length)
    return this.props.letters[position]
  }

  animate = () => {
    const nextRound = this.state.round + 1
    if (nextRound >= this.props.rounds) {
      return
    }
    this.setState({
      round: nextRound,
    })
    window.setTimeout(this.animate, this.props.speed)
  }

  render() {
    const shuffled = this.props.word
      .split('')
      .map((_, i) => this.randomSequenceFor(this.props.word[i]))
    return (
      <div
        style={{
          wordWrap: 'break-word',
          ...this.props.style,
        }}
      >
        {shuffled.map(letters => {
          const index = Math.min(this.state.round, letters.length - 1)
          return letters[index]
        })}
      </div>
    )
  }
}

export default WordShuffle



// WEBPACK FOOTER //
// ./src/components/WordShuffle.tsx